import axios from 'axios'

function unwrapResponse(response) {
  const payload = response?.data
  if (payload && typeof payload === 'object' && 'data' in payload && 'code' in payload) {
    if (Number(payload.code) !== 200 && Number(payload.code) !== 1) {
      throw new Error(payload.msg || '加载调用消耗失败')
    }
    return payload.data
  }
  return response?.data
}

/** 管理端：Agent 单次调用消耗列表（计费分析） */
export function fetchAgentCallUsageAdminList(params = {}) {
  return axios.get('/api/agent-call-usage/admin/list', { params, timeout: 60000 }).then(unwrapResponse)
}
